import {
  Box, IconButton, Paper, Tooltip, Typography,
} from '@mui/material';
import React from 'react';
import { InfoOutlined } from '@mui/icons-material';
import { EventFormStatus, FormMetadata } from '../../core/api/clients';
import { getColor } from '../../core/colors';
import FlightOperationNotificationList from './FlightOperationNotificationList';
import FlightOperationNotificationDrafts from './FlightOperationNotificationDrafts';
import useGetFormMetadata from '../../core/api/hooks/common/useGetFormMetadata';

function FlightOperationNotificationEventLanding({ formMetadata }:{ formMetadata: FormMetadata }) {
  if (!formMetadata || !(formMetadata.contributeRole)) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  const { data: authorizedForm } = useGetFormMetadata(formMetadata.componentName ?? '');

  if (!authorizedForm) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return (<React.Fragment />);
  }
  return (
    <React.Fragment>
      { authorizedForm.isContributor && (
        <Box display="flex" flexDirection="column">
          <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
            All Drafts
          </Typography>
          <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
            <FlightOperationNotificationDrafts />
          </Paper>
        </Box>
      )}
      <Box margin={2} />
      <Box display="flex" flexDirection="column">
        <Typography variant="h6" sx={{ mb: 0, color: getColor(formMetadata.color)[500], fontWeight: 300 }}>
          Submissions (Last 7 Days)
          <Tooltip title="This section shows the forms from the last 7 days using the date the report was created.">
            <IconButton>
              <InfoOutlined />
            </IconButton>
          </Tooltip>
        </Typography>
        <Paper variant="outlined" sx={{ mt: 0, mb: 1 }}>
          <FlightOperationNotificationList
            hours={168}
            statuses={[EventFormStatus.Submitted]}
            pageSize={10}
          />
        </Paper>
      </Box>
    </React.Fragment>
  );
}

export default FlightOperationNotificationEventLanding;
